import { combineReducers } from 'redux';
import usersReducer from './usersReducer';
import cartReducer from './cartReducer';
import settingsReducer from './settingsReducer';

const rootReducer = combineReducers({ user: usersReducer, cart: cartReducer, settings: settingsReducer });

export default rootReducer;